import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import RichTextViewer from 'components/RichTextViewer';

export default function ResearchContributions({ data, researchType }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  return (
    <div className="mt-3">
      <h4>{t('projectProposal.researchResult.researchContributions.label')}</h4>
      <div className="mt-3">
        <h4>
          {t('projectProposal.researchResult.researchContributions.contributionAndResolution')}
        </h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.contributionAndResolutionNote')}
        </p>
        <RichTextViewer
          value={data?.knowledgeContributionLevel ?? ''}
          showHeader={false}
          style={{ height: '300px' }}
          readOnly
        />
      </div>

      <div className="mt-3">
        <h4>{t('projectProposal.researchResult.researchContributions.practicalImpact')}</h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.practicalImpactNote')}
        </p>
        <RichTextViewer
          value={data?.practicalPolicyImpact ?? ''}
          showHeader={false}
          style={{ height: '300px' }}
          readOnly
        />
      </div>

      <div className="mt-3">
        <h4 className="mb-0">
          {t('projectProposal.researchResult.researchContributions.researchGroupDevelopment.label')}
        </h4>
        <p className="font-italic">
          {t('projectProposal.researchResult.researchContributions.researchGroupDevelopment.note')}
        </p>
        <RichTextViewer
          value={data?.teamDevelopmentLevel ?? ''}
          showHeader={false}
          style={{ height: '300px' }}
          readOnly
        />
      </div>

      <div className="mt-3">
        <h4 className="mb-0">
          {t(
            'projectProposal.researchResult.researchContributions.abilityTransferResearchResults.label'
          )}
        </h4>
        <p className="font-italic">
          {t(
            'projectProposal.researchResult.researchContributions.abilityTransferResearchResults.note'
          )}
        </p>
        {researchType?.code === 'implementation' && (
          <RichTextViewer
            value={data?.researchTransferability ?? ''}
            showHeader={false}
            style={{ height: '300px' }}
            readOnly
          />
        )}
      </div>
    </div>
  );
}

ResearchContributions.propTypes = {
  data: PropTypes.shape(),
  // eslint-disable-next-line react/forbid-prop-types
  researchType: PropTypes.object.isRequired,
};

ResearchContributions.defaultProps = {
  data: {},
};
